<template>
  <div>
    <div class="occupie"></div>
    <div class="fixBottom">
      <van-tabbar v-model="minActiveBar" @change="handleChangeMinTab"  active-color="#07c160" inactive-color="#000">
        <van-tabbar-item
          icon="home-o"
        >首页</van-tabbar-item>
        <van-tabbar-item
          icon="cluster-o"
          dot
        >考勤</van-tabbar-item>
        <van-tabbar-item
          icon="shopping-cart-o"
        >健康</van-tabbar-item>
        <van-tabbar-item
          icon="user-o"
        >个人</van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
export default {
  name: "DownTab",
  data () {
    return {
      minActiveBar: 0 // 默认选中栏
    }
  },
  props: {
    current: {
      type: Number,
      default: 0
    }
  },
  mounted () {
    this.role = this.$route.query.role;
    var current = Cookies.get("current");
    if (current == 0 || current > 0) {
      this.current = current;
    }
    /**
     * 判断当前页面是哪个页面,解决刷新时,tab默认为 1 的bug
     * (to.path === '/homeHeader' || to.path === '/teacherIndex' || to.path === '/headerAttendance' || to.path === '/teacherAttendance' || to.path === '/headerHealth' || to.path === '/teacherHealth' || to.path === '/headerPersonal' || to.path === '/teacherPersonal')
     */
    const CURRENTHREF = window.location.href;
    if (CURRENTHREF.includes('homeHeader') || CURRENTHREF.includes('teacherIndex')) {
      this.minActiveBar = 0
    } else if (CURRENTHREF.includes('headerAttendance') || CURRENTHREF.includes('teacherAttendance')) {
      this.minActiveBar = 1
    } else if (CURRENTHREF.includes('headerHealth') || CURRENTHREF.includes('teacherHealth')) {
      this.minActiveBar = 2
    } else if (CURRENTHREF.includes('headerPersonal') || CURRENTHREF.includes('teacherPersonal')) {
      this.minActiveBar = 3
    }
  },

  watch: {
    /**
     * 侦听路由的变化,控制底部tabbar的显示
     */
    $route (to, from) {
      const CURRENTHREF = window.location.href;
      if (CURRENTHREF.includes('homeHeader') || CURRENTHREF.includes('teacherIndex')) {
        this.minActiveBar = 0
      } else if (CURRENTHREF.includes('headerAttendance') || CURRENTHREF.includes('teacherAttendance')) {
        this.minActiveBar = 1
      } else if (CURRENTHREF.includes('headerHealth') || CURRENTHREF.includes('teacherHealth')) {
        this.minActiveBar = 2
      } else if (CURRENTHREF.includes('headerPersonal') || CURRENTHREF.includes('teacherPersonal')) {
        this.minActiveBar = 3
      }
    }
  },
  methods: {
    /**
     * 切换商城底部tab的方法
     */
    handleChangeMinTab () {
      if (this.minActiveBar === 0) {
        Cookies.set("current", 0);
        var role = Cookies.get("role");
        if(role == 1){
          this.$router.push({ path:'/teacherIndex', replace: true});
        }else{
          this.$router.push({ path:'/homeHeader', replace: true});
        }
      } else if (this.minActiveBar === 1) {
        Cookies.set("current", 1);
        var role = Cookies.get("role");
        if(role == 1){
          this.$router.push({path: '/teacherAttendance', replace: true});
        } else {
          this.$router.push({path: '/headerAttendance', replace: true});
        }
      } else if (this.minActiveBar === 2) {
        Cookies.set("current", 2);
        var role = Cookies.get("role");
        if(role == 1) {
          this.$router.push({path: '/teacherHealth', replace: true});
        } else {
          this.$router.push({path: '/headerHealth', replace: true});
        }
      } else if (this.minActiveBar === 3) {
        Cookies.set("current", 3);
        var role = Cookies.get("role");
        if(role == 1){
          this.$router.push({ path:'/teacherPersonal', replace: true});
        }else{
          this.$router.push({ path:'/headerPersonal', replace: true});
        }
      }
    },
    toMy () {
      Cookies.set("current", 3);
      var role = Cookies.get("role");
      if(role == 1){
        this.$router.push({ path:'/teacherPersonal'});
      }else{
        this.$router.push({ path:'/headerPersonal'});
      }
    },
    toAct () {
      Cookies.set("current", 0);
      var role = Cookies.get("role");
      if(role == 1){
        this.$router.push({ path:'/teacherIndex'});
      }else{
        this.$router.push({ path:'/homeHeader'});
      }
    },
    attendance () {
      Cookies.set("current", 1);
      var role = Cookies.get("role");
      if(role == 1){
        this.$router.push({path: '/teacherAttendance'});
      } else {
        this.$router.push({path: '/headerAttendance'});
      }
    },
    health () {
      Cookies.set("current", 2);
      var role = Cookies.get("role");
      if(role == 1) {
        this.$router.push({path: '/teacherHealth'});
      } else {
        this.$router.push({path: '/headerHealth'});
      }
    }
  },
  created () {
    var current =  Cookies.get("current") == undefined? 0:Cookies.get("current");
    this.current = current;
  }
}
</script>

<style scoped>
  .occupie{
    height:110px;
    width: 100%;
  }
  .part span.active{
    color: #0082CD;
  }
  .part{
    width: 25%;
    float: left;
    font-size: 20px;
    color: #AEAEAE;
  }
  .icon{
    width: 45px;
    height: 45px;
    margin: 15px auto 5px;
    display: block;
  }
  .fixBottom{
    width:100%;
    height:98px;
    background:rgba(255,255,255,1);
    box-shadow:0px -4px 3px 0px rgba(226,225,225,0.5);
    position: fixed;
    left: 0;
    bottom: 0;
    text-align: center;
  }

</style>
